/*
toolbox混入，将公共的toolbox中的feature混入到vue中
使用方法
找到historytoolbox的feature，然后加入下面的内容
 */
// 标注
/*
          myMark: {
            title: '标注',
            show: true,
            icon: this.markPoint.markIcon,
            iconStyle: {
              borderColor: this.markPoint.isMark ?'#74ACC8' : this.$store.state.toolboxcolor
            },
            onclick:  ()=>{
              console.log('实时模式下的')
              let option = {
                series: [{
                  markPoint: {
                    data: []
                  },
                }],
                toolbox: {
                  feature: {
                    myMark: {
                      iconStyle: {
                        borderColor: '#74ACC8'
                      }
                    }
                  }
                }
              }
              if(this.markPoint.isMark) {
                // console.log('当前是标记状态下')
                // 如果当前是标记状态,需要取消标记
                this.markPoint.isMark = false;
                option.toolbox.feature.myMark.iconStyle.borderColor = this.$store.state.toolboxcolor
                option.series[0].markPoint= { // 恢复最大值下表样式
                  symbol: 'path://M 512 128 l -213.333 256 l 170.667 0 l 0 512 l 85.333 0 l 0 -512 l 170.667 0 Z',
                  symbolSize: 15,
                  itemStyle: {
                    color: this.$store.state.textcolor,
                  },
                  data: [{
                    name: 'max',
                    y: '92%',
                    xAxis: maxX,
                  }]
                }
              } else {
                this.markPoint.isMark = true;
                this.markPoint.markPointX = []
              }
              this.mychart.setOption(option)
            }
          },


 */
// 谐频
/*
          myResonance: {
            show: true,
            title: '谐频',
            icon: this.markLine.icon,
            iconStyle: {
              borderColor: this.markLine.isResonance ?'#74ACC8' : this.$store.state.toolboxcolor
            },
            onclick:  ()=>{
              let option = {
                series: [{
                  markLine: {
                    data: []
                  },
                }],
                toolbox: {
                  feature: {
                    myResonance: {
                      iconStyle: {
                        borderColor: '#74ACC8'
                      }
                    }
                  }
                }
              }
              if(this.markLine.isResonance) {
                // 如果当前是标记状态,需要取消标记
                this.markLine.isResonance = false;
                // 还原图表线条颜色
                option.toolbox.feature.myResonance.iconStyle.borderColor = this.$store.state.toolboxcolor
              } else {
                this.markLine.isResonance = true;
              }
              this.mychart.setOption(option)
            }
          },

 */

import toolboxMoreMixin from "./toolboxMoreMixin";
import graphicMixin from "./graphicMixin";
import {timestampToTimeFormat} from "../components/ComUtils/TimeFormat";
import {numberUtilsMixin} from "./numberUtilsMixin";
import event from "@/assets/event";
import * as XLSX from "sheetjs-style";

const toolboxMixin = {
  mixins: [toolboxMoreMixin, graphicMixin, numberUtilsMixin],

  data() {
    return {
      proMarkPoint: [],
      markPoint: { // 数据标注点相关变量
        show: true, // 是否进行 标注
        markPointX: [], // 当前标记的数据
        markIcon: 'M3,9.8C2.9,9.7,2.9,9.6,3,9.5l5.3-5.2c0.2-0.2,0.4-0.2,0.6,0l1.4,1.4c0.2,0.2,0.2,0.4,0,0.6L5,11.4\n' +
          '\t\tc-0.1,0.1-0.3,0.1-0.4,0L3,9.8z M7,5.9l0.6,0.6 M5.6,7l0.7,0.7 M4.4,8.4L5,9 M5,5.1L3.9,4.1c0,0-0.1,0-0.2,0L2.6,5.2\n' +
          '\t\tc0,0,0,0.1,0,0.2l1.1,1.1 M8,10.7l0.9,0.9h1.2v-1.2L9.3,9.5 M7,0.5C3.4,0.5,0.5,3.4,0.5,7s2.9,6.5,6.5,6.5s6.5-2.9,6.5-6.5\n' +
          '\t\tS10.6,0.5,7,0.5z',
        isMark: false,
      },
      myMarkPoint: {
        icon: 'M13.5,7c0,3.6-2.8,6.5-6.5,6.5c-3.6,0-6.5-2.8-6.5-6.5S3.4,0.5,7,0.5C10.6,0.5,13.5,3.5,13.5,7z M3.4,5.3\n' +
          'c-0.6,0-1,0.4-1,1s0.4,1,1,1s1-0.4,1-1S4,5.3,3.4,5.3z M9,2.9C8.4,2.9,7.9,3.4,7.9,4S8.4,5.1,9,5.1s1.1-0.5,1.1-1.1S9.6,2.9,9,2.9z\n' +
          '\tM6.1,9.1c-0.7,0-1.1,0.5-1.1,1.1s0.5,1.1,1.1,1.1s1.1-0.5,1.1-1.1C7.3,9.6,6.7,9.1,6.1,9.1z M10.8,7.2c-0.5,0-1,0.5-1,1s0.5,1,1,1\n' +
          's1-0.5,1-1C11.8,7.6,11.4,7.2,10.8,7.2z M4,7.1L5.4,9 M8.6,5.1l-2,4 M9.4,5.2l0.9,1.9',
        state: false
      },
      flagX: '',
      flagY: '',
      dataX: [],
      dataY: [],
      title: '',
      type: '',
      trendFlag: false,
      modelFlag: true, //true表示时间点等分， false表示数据点等分
      change3DX: { // X轴坐标功能
        state: 'Hz', // 目前状态
        icon: "M341.33,672.75c-88.52,0-171.75-34.47-234.34-97.07C44.39,513.08,9.92,429.86,9.92,341.33S44.39,169.58,106.99,106.99C169.58,44.39,252.81,9.92,341.33,9.92s171.75,34.47,234.35,97.07c62.59,62.59,97.07,145.82,97.07,234.34s-34.47,171.75-97.07,234.35c-62.6,62.59-145.82,97.07-234.35,97.07Zm0-648.54C166.47,24.21,24.21,166.47,24.21,341.33s142.26,317.12,317.12,317.12,317.12-142.26,317.12-317.12S516.19,24.21,341.33,24.21Zm66.21,531.12c-1.92,0-3.72-.74-5.08-2.09-1.34-1.33-2.11-3.16-2.11-5.03,0-1.89,.73-3.67,2.08-5.01l75.26-75.24H221.75c-3.88-.02-7.04-3.21-7.02-7.12,0-3.96,3.15-7.17,7.02-7.17h255.95l-75.26-75.24c-1.32-1.32-2.08-3.15-2.08-5.03,0-1.86,.77-3.69,2.1-5.01,1.37-1.36,3.17-2.11,5.09-2.11s3.7,.74,5.06,2.08l72.44,72.43c1.14,1.14,1.84,2.6,2.02,4.19l.9,7.82,7.82,.9c3.6,.41,6.31,3.46,6.3,7.08,0,3.68-2.68,6.74-6.24,7.13l-7.88,.86-.9,7.88c-.18,1.58-.9,3.06-2.02,4.18l-72.49,72.49c-1.32,1.3-3.1,2.03-5.01,2.03Zm-132.42-238.93c-1.92,0-3.7-.72-5.02-2.04l-72.48-72.48c-1.13-1.12-1.84-2.6-2.02-4.17l-.89-7.85-7.86-.88c-3.59-.4-6.29-3.43-6.27-7.05,0-3.7,2.69-6.76,6.25-7.16l7.87-.87,.9-7.87c.18-1.57,.9-3.05,2.02-4.17l72.49-72.49c1.32-1.3,3.1-2.03,5.01-2.03s3.72,.74,5.08,2.1c1.34,1.33,2.1,3.15,2.11,5.02,0,1.88-.75,3.71-2.07,5.02l-75.26,75.24h255.94c3.88,0,7.03,3.21,7.03,7.15s-3.15,7.14-7.03,7.14H204.98l75.26,75.24c1.32,1.32,2.08,3.15,2.07,5.02,0,1.88-.77,3.7-2.09,5.02-1.38,1.39-3.14,2.11-5.09,2.11Z",
        lastXData: [],
        lastMarkPoint: null,
        oneFrequency: 50,
      },
      // 主辅游标
      PrimarySecondary: {
        icon: 'M13.5,7c0,3.7-2.9,6.5-6.5,6.5S0.5,10.5,0.5,7c0-3.7,2.9-6.5,6.5-6.5S13.5,3.3,13.5,7z M4.4,3.9V10 M7,3.9V10\n' +
          '\t M9.5,3.9V10',
        // icon: 'M13.4,7c0,3.6-2.9,6.4-6.4,6.4S0.6,10.5,0.6,7c0-3.6,2.9-6.4,6.4-6.4S13.4,3.4,13.4,7z M4.4,3.9V10 M7,3.9V10\n' +
        //   '\t M9.5,3.9V10',
        //icon: 'M546.2,545.8H3 M120.7,39.2v50.9 M120.7,265.3v50.9 M120.7,378.3v50.9 M120.7,491.4v50.9 M96.4,77.8h48.7 M120.7,152.2v50.9 M275.5,152.2v50.9 M275.5,265.3v50.9 M275.5,378.3v50.9 M275.5,491.4v50.9 M253.2,77.8h44.7 M275.5,39.2v50.9 M430.4,152.2v50.9 M430.4,265.3v50.9 M430.4,378.3v50.9 M430.4,491.4v50.9 M408.1,77.8h44.7 M430.4,39.2v50.9',
        secondaryIcon: 'M53.1,484.5h458 M157.9,37.5v26 M135.5,60.7h44.7 M157.9,86v29.9 M157.9,138.4v29.9 M157.9,190.7v29.9 M157.9,243.1V273 M157.9,295.5v29.9 M157.9,347.9v29.9 M157.9,400.3v29.9 M157.9,452.7v29.9 M282.1,37.5v26 M259.8,60.7h44.7 M282.1,86v29.9 M282.1,138.4v29.9 M282.1,190.7v29.9 M282.1,243.1V273 M282.1,295.5v29.9 M282.1,347.9v29.9 M282.1,400.3v29.9 M282.1,452.7v29.9 M406.4,37.5v26 M384,60.7h44.7 M406.4,86v29.9 M406.4,138.4v29.9 M406.4,190.7v29.9 M406.4,243.1V273 M406.4,295.5v29.9 M406.4,347.9v29.9 M406.4,400.3v29.9 M406.4,452.7v29.9',
        primaryIcon: 'M53.1,484.5h458.1 M157.9,37.5v447 M135.5,61.7h44.8 M282.1,37.5v447 M259.8,61.7h44.7 M406.4,37.5v447 M384,61.7h44.8',
        isMark: true, // 主游标
        preLines: [], // 当前的主辅游标数据，方便趋势图和转速趋势图游标同步的时候使用
      },
      PrimaryLine: null,
      SecondaryLine: null,
      SecondaryLineY: null,
      PrimaryLineY: null,
      PrimaryLineParam: null,
      SecondaryLineParam: null,
      alarmFlag: false,//报警线是否开启
      aline: [],//报警线信息
      tongDaoType: '0', //多通道显示报警线按钮，单通道不显示
      ifAlarm: 1, //是否启用报警线
    }
  },
  mounted() {
  },
  created() {
    this.$store.state.modelFlag = this.modelFlag;
  },
  methods: {

    //存储画图信息
    saveGraphData(flagX, flagY, dataX, dataY, title, type, trendFlag) {
      this.flagX = flagX;
      this.flagY = flagY;
      this.dataX = dataX;
      this.dataY = dataY;
      this.title = title;
      this.type = type;
      // console.log('mytype',type);
      this.trendFlag = trendFlag;
      // console.log('存储的数据', flagX, flagY, dataX, dataY, title, type);
    },
    /**
     * 测量文字宽度
     */
    measureLabelWidth(text, style = {}) {
      const div = document.createElement("div");
      div.style.position = "absolute";
      div.style.left = "-9999px";
      div.style.top = "-9999px";
      div.style.whiteSpace = "nowrap";
      div.style.fontSize = (style.fontSize || 12) + "px";
      div.style.fontFamily = style.fontFamily || "sans-serif";
      div.style.padding = `${style.paddingY || 4}px ${style.paddingX || 8}px`;

      div.textContent = text;
      document.body.appendChild(div);
      const width = div.getBoundingClientRect().width;
      document.body.removeChild(div);

      return width;
    },
    /**
     * 在图上画条线，lines是位置坐标
     * @update 更新日期 2022-11-09 10:25:11
     * @param lines 格式 [{ xAxis: 2022-01-25 10:26:14.069, lineStyle: { color: '#00ff00' } }, { xAxis: 2022-01-25 10:26:14.069 }]
     */
    drawLine(lines, click = false) {
      console.log("drawLine方法被调用");
      console.log("happen->drawLine", lines, click);

      let marklineData = [];
      try {
        marklineData = this.mychart.getOption().series[0].markLine.data;
      } catch (e) {}
      marklineData = marklineData.filter(i => i.id !== "Auxiliary-Cursor" && i.id !== "Main-Cursor");

      let processedLines = [];
      const chartWidth = this.mychart.getWidth();
      const chartHeight = this.mychart.getHeight();


      // 获取x轴相关信息
      const xAxisOption = this.mychart.getOption().xAxis[0];
      let xDataRange = 0;

      if (Array.isArray(xAxisOption.data) && xAxisOption.data.length > 0) {
        const firstData = xAxisOption.data[0];
        const isTimestamp = typeof firstData === 'number' && firstData > 1000000000;

        if (isTimestamp) {
          // 时间戳格式
          const xMin = Math.min(...xAxisOption.data);
          const xMax = Math.max(...xAxisOption.data);
          xDataRange = xMax - xMin;
        } else {
          // 其他数值格式
          const xMin = Math.min(...xAxisOption.data.map(d => parseFloat(d)));
          const xMax = Math.max(...xAxisOption.data.map(d => parseFloat(d)));
          xDataRange = xMax - xMin;
        }
      }

      const isTrendChart = this.typename === '趋势图' || this.graphType === '趋势图';

      const labelStyle = {
        fontSize: 12,
        fontFamily: 'sans-serif',
        paddingX: 8,
        paddingY: 4,
        safeMargin: 15
      };


      // 固定游标长度为30px
      this.cursorLength = 60;
      // 获取x轴实际范围
      const xAxisModel = this.mychart.getModel().getComponent('xAxis', 0);
      const xAxisExtent = xAxisModel ? xAxisModel.axis.getExtent() : [0, chartWidth - 100];
      const xAxisStart = xAxisExtent[0]; // x轴起始位置（相对于容器）
      const xAxisEnd = xAxisExtent[1]; // x轴结束位置（相对于容器）
      const xAxisLength = xAxisEnd - xAxisStart; // x轴宽度

      // 计算偏移量：(容器宽度 - x轴宽度) ÷ 2
      const offset = (chartWidth - xAxisLength) / 2;

      // 转换xPixel为相对于x轴起始点的位置，并应用偏移量调整
      const cursorPixelPositions = lines.map(line => {
        const containerPixel = this.mychart.convertToPixel('xAxis', line.xAxis);
        const xPixelFromXAxisStart = containerPixel - xAxisStart; // 相对于x轴起始点的像素位置
        const adjustedXPixel = xPixelFromXAxisStart - offset; // 应用偏移量调整后的实际xPixel
        return {
          line,
          containerPixel, // 相对于容器左侧的像素位置
          xPixel: adjustedXPixel // 调整后的实际xPixel，相对于x轴起始点
        };
      }).filter(item => typeof item.containerPixel === 'number');

      // 单游标处理
      if (cursorPixelPositions.length === 1) {
        const { line, containerPixel, xPixel } = cursorPixelPositions[0];

        // 使用统一的x轴范围
        const xPixelToLeft = xPixel; // 调整后相对于x轴起始点的距离
        const xPixelToRight = xAxisLength - xPixel; // 调整后相对于x轴结束点的距离

        let ydata = this.mychart.getOption().series[line.seriesNameIndex] ?
          this.mychart.getOption().series[line.seriesNameIndex].data[line.xIndex] :
          this.mychart.getOption().series[0].data[line.xIndex];
        let yvalue = Array.isArray(ydata)
          ? this.roundToDecimalPlaces(parseFloat(ydata[1]), 2)
          : this.roundToDecimalPlaces(parseFloat(ydata), 2);

        const getLabelText = () => isTrendChart ? `[${yvalue}]` : `[${this.roundToDecimalPlaces(parseFloat(line.xAxis),2)}, ${yvalue}]`;

        const labelConfig = {
          show: true,
          align: 'left',
          verticalAlign: 'top',
          distance: 0,
          formatter: () => getLabelText().replace(/\n/g, ' '),
          padding: [labelStyle.paddingY, labelStyle.paddingX],
          borderRadius: 3,
          color: line.id === 'Main-Cursor' ? this.$store.state.primarySecondaryColor[0] : this.$store.state.primarySecondaryColor[1],
          fontSize: labelStyle.fontSize,
          overflow: 'truncate'
        };

        if (xPixelToLeft <= this.cursorLength) {
          // 靠近左边界，标签显示在右侧
          labelConfig.align = 'left';
        } else if (xPixelToRight <= this.cursorLength) {
          // 靠近右边界，标签显示在左侧
          labelConfig.align = 'right';
        } else {
          // 中间区域，标签默认显示在右侧
          labelConfig.align = 'left';
        }
        processedLines.push({ ...line, label: labelConfig });
      }
      // 双游标处理
      else if (cursorPixelPositions.length === 2) {
        const [cursor1, cursor2] = cursorPixelPositions;
        const { line: line1, containerPixel: containerPixel1, xPixel: x1 } = cursor1; // 原始第一个游标及像素位置
        const { line: line2, containerPixel: containerPixel2, xPixel: x2 } = cursor2; // 原始第二个游标及像素位置
        const cursorDist = Math.abs(x1 - x2);  // 游标间距（相对于x轴起始点）
        const xAxisLength = xAxisEnd - xAxisStart; // x轴实际长度
        // 辅助函数定义
        const getYValue = (line) => {
          let ydata = this.mychart.getOption().series[line.seriesNameIndex] ?
            this.mychart.getOption().series[line.seriesNameIndex].data[line.xIndex] :
            this.mychart.getOption().series[0].data[line.xIndex];
          return Array.isArray(ydata) ? this.roundToDecimalPlaces(parseFloat(ydata[1]), 2) : this.roundToDecimalPlaces(parseFloat(ydata), 2);
        };

        const getLabelText = (line, yvalue) => isTrendChart ? `[${yvalue}]` : `[${this.roundToDecimalPlaces(parseFloat(line.xAxis),2)}, ${yvalue}]`;

        const createLabelConfig = (line, yvalue) => ({
          show: true,
          align: 'left',
          verticalAlign: 'top',
          distance: 0,
          formatter: () => getLabelText(line, yvalue).replace(/\n/g, ' '),
          padding: [labelStyle.paddingY, labelStyle.paddingX],
          borderRadius: 3,
          color: line.id === 'Main-Cursor' ? this.$store.state.primarySecondaryColor[0] : this.$store.state.primarySecondaryColor[1],
          fontSize: labelStyle.fontSize,
          overflow: 'truncate'
        });

        const y1 = getYValue(line1);
        const y2 = getYValue(line2);
        const labelConfig1 = createLabelConfig(line1, y1); // 第一个游标的标签配置
        const labelConfig2 = createLabelConfig(line2, y2); // 第二个游标的标签配置

        const leftCursor = x1 < x2 ? cursor1 : cursor2; // xPixel较小的游标为左游标
        const rightCursor = x1 < x2 ? cursor2 : cursor1; // xPixel较大的游标为右游标
        const leftCursorPixel = leftCursor.xPixel;  // 左游标相对于x轴起始点的距离
        const rightCursorPixel = rightCursor.xPixel;  // 右游标相对于x轴起始点的距离
        const leftCursorIsLine1 = leftCursor.line.id === line1.id; // 判断左游标是否为原始第一个游标

        const rightCursorNearRight = xAxisLength - rightCursorPixel <= this.cursorLength; // 右游标到右边界的距离是否小于游标长度
        const leftCursorNearLeft = leftCursorPixel <= this.cursorLength; // 左游标到左边界的距离是否小于游标长度

        //游标间距大于等于游标长度的情况
        if (cursorDist >= this.cursorLength) {
          // 1.1 双边界附近处理：两个游标分别靠近左右两侧
          if (leftCursorNearLeft && rightCursorNearRight) {
            if (leftCursorIsLine1) {
              labelConfig1.align = 'left'; // 左游标（原始第一个游标）展示在左侧
              labelConfig2.align = 'right'; // 右游标（原始第二个游标）展示在右侧
            } else {
              labelConfig2.align = 'left'; // 左游标（原始第二个游标）展示在左侧
              labelConfig1.align = 'right'; // 右游标（原始第一个游标）展示在右侧
            }
          }
          // 1.2 右边界附近处理：只有右游标靠近右边界
          else if (rightCursorNearRight) {
            if (leftCursorIsLine1) {
              labelConfig1.align = 'right'; // 左游标（原始第一个游标）展示在右侧
              labelConfig2.align = 'right'; // 右游标（原始第二个游标）展示在右侧
            } else {
              labelConfig2.align = 'right'; // 左游标（原始第二个游标）展示在右侧
              labelConfig1.align = 'right'; // 右游标（原始第一个游标）展示在右侧
            }
          }
          // 1.3 左边界附近处理：只有左游标靠近左边界
          else if (leftCursorNearLeft) {
            if (leftCursorIsLine1) {
              labelConfig1.align = 'left'; // 左游标（原始第一个游标）展示在左侧
              labelConfig2.align = 'left'; // 右游标（原始第二个游标）展示在右侧
            } else {
              labelConfig2.align = 'left'; // 左游标（原始第二个游标）展示在左侧
              labelConfig1.align = 'left'; // 右游标（原始第一个游标）展示在右侧
            }
          }
          // 1.4 中间区域处理
          else {
            if (leftCursorIsLine1) {
              labelConfig1.align = 'right'; // 左游标（原始第一个游标）标签显示在右侧
              labelConfig2.align = 'left'; // 右游标（原始第二个游标）标签显示在左侧
            } else {
              labelConfig2.align = 'right'; // 左游标（原始第二个游标）标签显示在右侧
              labelConfig1.align = 'left'; // 右游标（原始第一个游标）标签显示在左侧
            }
          }
        }
        else {
          // 游标间距小于游标长度（50px）
          // 右边界小于游标长度
          if (rightCursorNearRight) {
            if (leftCursorIsLine1) {
              labelConfig1.align = 'right'; //左侧游标（原始第一个游标）展示在左侧
              labelConfig2.show = false; // 隐藏左侧游标（原始第二个游标）
            } else {
              labelConfig2.align = 'right'; // 右侧游标（原始第二个游标）展示在左侧
              labelConfig1.show = false; // 隐藏左侧游标（原始第一个游标）
            }
          }
          // 左边界小于游标长度
          else if (leftCursorNearLeft) {
            if (leftCursorIsLine1) {
              labelConfig1.show = false; // 隐藏左侧游标（原始第一个游标）
              labelConfig2.align = 'left'; // 右侧游标（原始第二个游标）展示在右侧
            } else {
              labelConfig2.show = false; // 隐藏左侧游标（原始第二个游标）
              labelConfig1.align = 'left'; // 右侧游标（原始第一个游标）展示在右侧
            }
          }
          else {
            if (leftCursorIsLine1) {
              labelConfig1.align = 'right'; // 左游标（原始第一个游标）标签显示在右侧
              labelConfig2.align = 'left'; // 右游标（原始第二个游标）标签显示在左侧
            } else {
              labelConfig2.align = 'right'; // 左游标（原始第二个游标）标签显示在右侧
              labelConfig1.align = 'left'; // 右游标（原始第一个游标）标签显示在左侧
            }
          }
        }
        // 添加到处理后的线条数组
        processedLines.push({ ...line1, label: labelConfig1 });
        processedLines.push({ ...line2, label: labelConfig2 });
      }
      const option = {
        series: [
          {
            type: "line",
            markLine: {
              symbol: ['none', 'none'],
              lineStyle: { type: "dashed", color: this.$store.state.textcolor },
              label: { show: true },
              animation: false,
              data: [...processedLines, ...marklineData]
            }
          }
        ]
      };
      this.mychart.setOption(option);
    },
    /**
     * 显示两个x轴的差
     * 需要修改optin的title，添加第二个标题，通过修改第二个标题实现显示功能
     * @update 更新日期2022-03-18 09:06:05
     * @param time1
     * @param time2
     */
    xAxisSub(a1, a2, seriesIndex1=0, seriesIndex2=0) {
      // a1 保存小的坐标 a2保存大的坐标
      if(a1 > a2) {
        let t = a2;
        a2 = a1;
        a1 = t;
        let t2 = seriesIndex1
        seriesIndex1 = seriesIndex2
        seriesIndex2 = t2
      }

      // 计算y轴的差值
      const op = this.mychart.getOption()
      // 将获取时间的坐标
      const y1 = op.xAxis[0].data.indexOf(a1)
      const y2 = op.xAxis[0].data.indexOf(a2)
      // 幅值差量
      const subFuzhi = op.series[seriesIndex1].data[y2] - op.series[seriesIndex2].data[y1]
      const titles = op.title
      let xName = op.xAxis[0].name.substring(1, op.xAxis[0].name.length - 1);
      let yName = op.yAxis[0].name.substring(1, op.yAxis[0].name.length - 1)
      let titleIndex = this.subTitleData.index
      titles[titleIndex].text = `[差量${this.roundToDecimalPlaces((a2 - a1),2)}${xName},${this.roundToDecimalPlaces(subFuzhi,2)}${yName}]`
      const option = {
        title: titles
      }
      this.mychart.setOption(option)
    },
    /**
     * 画主辅游标 drawLinePrimarySecondary
     * 因为之前的画两条线的函数不需要了，所以直接用这个代替画两条线的函数drawLineAndProLine
     * 就可以实现主辅游标的功能了
     * @param line xAxis
     * @param seriesNameIndex
     * @param param
     */
    drawLineAndProLine(line, seriesNameIndex, param, isMark=null) {
      let op = this.mychart.getOption()
      let data = op.series[0].markPoint && op.series[0].markPoint.data ? op.series[0].markPoint.data : []
      let xValue = op.xAxis[0].type == 'category' ? param.name.toString() : param.name
      let yValue = op.xAxis[0].type == 'category' ? param.seriesY.toString() : param.seriesY[1]

      if(isMark || (isMark==null&&this.PrimarySecondary.isMark)) {
        this.PrimaryLine = line
        this.PrimaryLineParam = param
        this.PrimaryLineSeriesNameIndex = seriesNameIndex
        let option = {
          series:[]
        }
        data = data.filter(item => {
          return item.name != '主游标点'
        })
        data.push({
          name: '主游标点',
          coord:[xValue, yValue],
          symbol: 'circle',
          symbolSize: 5,
          itemStyle: {
            color: this.$store.state.primarySecondaryColor[0],
          }
        })
        option.series[0] = {
          type: 'line',
          markPoint:{
            data
          }
        }
        this.mychart.setOption(option)
      } else {
        this.SecondaryLine = line
        this.SecondaryLineParam = param
        this.SecondaryLineSeriesNameIndex = seriesNameIndex
        let option = {
          series:[]
        }
        data = data.filter(item => {
          return item.name != '辅游标点'
        })
        data.push({
          name: '辅游标点',
          coord:[xValue, yValue],
          symbol: 'circle',
          symbolSize: 5,
          itemStyle: {
            color: this.$store.state.primarySecondaryColor[1]
          }
        })
        option.series[0] = {
          type: 'line',
          markPoint:{
            data
          }
        }
        this.mychart.setOption(option)
      }
      let lines = []
      if(this.PrimaryLine) {
        lines.push({
          id: 'Main-Cursor',
          xAxis: '' + this.PrimaryLine,
          lineStyle: {
            color: this.$store.state.primarySecondaryColor[0],
            type: 'dashed',
          },
          xIndex: this.PrimaryLineParam.xIndex, // 记录x轴的索引，方便游标同步的时候计算y轴的值
          seriesNameIndex: this.PrimaryLineSeriesNameIndex
        })
      }
      if(this.SecondaryLine) {
        lines.push({
          id: 'Auxiliary-Cursor',
          xAxis: '' + this.SecondaryLine,
          lineStyle: {
            color: this.$store.state.primarySecondaryColor[1]
          },
          xIndex: this.SecondaryLineParam.xIndex, // 记录x轴的索引，方便游标同步的时候计算y轴的值
          seriesNameIndex: this.SecondaryLineSeriesNameIndex
        })
      }
      if(lines.length === 2) {
        this.xAxisSub(this.PrimaryLine, this.SecondaryLine, this.PrimaryLineSeriesNameIndex, this.SecondaryLineSeriesNameIndex,this.PrimaryLineParam.xIndex, this.SecondaryLineParam.xIndex)
      }
      console.log("存入的PrimarySecondary.preLines", lines)
      //console.log("asjdkajdajd",this.mychart.getOption())
      this.PrimarySecondary.preLines = lines
      // console.log("happen->PrimarySecondary", this.PrimarySecondary.preLines)
      //this.$options.cursorLines=lines
      //this.$store.state.prelines=lines
      //console.log("游标  撒大大",this.$store.state.prelines)
      let option = this.mychart.getOption()
      option.cursorLines=lines

      console.log("asdadadadaaaaaa",option)
      this.mychart.setOption(option)
      this.drawLine(lines, true)
      // 画主辅游标的时候，如果频族带的状态是开着的，那么进行刷新
      // if(this.sidebandFamilyFun) {
      //   this.sidebandFamilyFun()
      // }
    },
    /**
     * 用来适配转速趋势图和趋势图游标同步
     * @param lines
     */
    refreshLineAndProLine(lines) {
      if(lines.length === 2) {
        this.xAxisSub(lines[0].xAxis, lines[1].xAxis)
      }
      let lines2 = []
      for(const l of lines) {
        // if(l.label.formatter) delete l.label.formatter
        lines2.push(l)
      }
      let option = this.mychart.getOption()
      option.cursorLines=lines
      this.mychart.setOption(option)
      //this.$options.cursorLines=lines
      //this.$store.state.prelines=lines
      this.drawLine(lines)
    },


    /**
     * 匹配其它图谱传过来的时间，同步游标信息
     * @param x
     * @param isMark
     */
    drawMarkLine(x,isMark){
      //series为空，无数据不需要同步
      if(this.mychart.getOption().series.length == 0){
        return
      }
      let xTime = new Date(x).getTime()
      let option = this.mychart.getOption()
      let xAxisData = option.xAxis[0].data
      // 将获取的时间，遍历成时间戳
      let xAxisDataTime = xAxisData.map(x => new Date(x).getTime())
      // 定义一个函数，用于找到最接近给定值的元素
      // 找到最接近的时间值
      xTime = this.findClosestValue(xTime, xAxisDataTime);
      let xIndex = xAxisDataTime.indexOf(xTime);
      let param = {};
      param.name = xAxisData[xIndex];
      param.xIndex = xIndex
      param.seriesNameIndex = 0
      param.seriesName = option.series[0].name;
      param.seriesId = option.series[0].id;
      param.seriesY = option.series[0].data[xIndex]
      param.yIndex = xIndex
      this.drawLineAndProLine(param.name, 0, param, isMark)
    },

    /**
     * 用于适配不同类型测点的游标同步
     * @param lines
     */
    drawMultiPointCursorAlignment(lines){
      // 取出传入的时间
      // console.log('画之前的参照划线数据：',lines)

      let times  = []
      times[0] = new Date(lines[0].xAxis).getTime()
      // times[1] = lines[1].xAxis
      // 取图片的option参数，获取xAxis的值
      let option = this.mychart.getOption()
      let xAxisData = option.xAxis[0].data
      // 将获取的时间，遍历成时间戳
      for (let i = 0; i < xAxisData.length; i++){
        xAxisData[i] = new Date(xAxisData[i]).getTime()
      }
      // 定义一个函数，用于找到最接近给定值的元素
      // 找到最接近的时间值
      let min0 = this.findClosestValue(times[0], xAxisData);
      // console.log("找到的最接近的值：", min0);
      // console.log("目标数据的取值数组：", xAxisData);

      // 找到对应的下标
      let min0Index = xAxisData.indexOf(min0);
      // console.log('下标', min0Index);

      // 找到对应的 x 轴值
      let min0XAxis = xAxisData[min0Index];
      // console.log('minXAxis', min0XAxis);

      // 将 x 轴值转换为时间戳，然后赋给 lines[0].xAxis
      lines[0].xAxis = timestampToTimeFormat(min0XAxis);
      // console.log('lines[0].xAxis', lines[0].xAxis);
      lines[0].xIndex = min0Index

      if(lines.length === 2) {
        times[1] = new Date(lines[1].xAxis).getTime()
        for (let j = 0; j < xAxisData.length; j++){
          xAxisData[j] = new Date(xAxisData[j]).getTime()
        }
        let min1 = this.findClosestValue(times[1], xAxisData)
        let min1Index = xAxisData.indexOf(min1);
        let min1XAxis = xAxisData[min1Index];
        lines[1].xAxis = timestampToTimeFormat(min1XAxis);
        lines[1].xIndex = min1Index

        this.xAxisSub(lines[0].xAxis, lines[1].xAxis)
      }
      let lines2 = []
      for(const l of lines) { // 为什么写这个，我也不知道这个作用是什么，既然存在，就有存在的道理，就选择保留这个循环，冒似真的没啥用
        if(l.label.formatter) delete l.label.formatter
        lines2.push(l)
      }
      lines = lines2
      // console.log('处理后目标划线数据：',lines)
      //let option = this.mychart.getOption()
      option.cursorLines=lines
      this.mychart.setOption(option)
      //this.$options.cursorLines=lines
      //this.$store.state.prelines=lines
      this.drawLine(lines)
    },
    /**
     * 找出相近的值
     * @param arr
     * @param target
     * @returns {*}
     */
    findClosestValue(target, arr) {
      let closest = arr[0];
      arr.forEach((value) => {
        if (Math.abs(value - target) < Math.abs(closest - target)) {
          closest = value;
        }
      });
      return closest;
    },

    /**
     * 3D
     * x轴切换
     */

    change3DXFun() {
      const chart = this.mychart;
      const op = chart.getOption();
      let xData = op.xAxis3D[0].data; // value 类型时是 undefined
      const isCategory = op.xAxis3D[0].type === 'category';

      this.offset = '';
      this.mainCursor = '';
      this.auxiliaryCursor = '';

      // 重置标记和其它相关状态
      if (this.PrimaryLine != undefined) {
        this.PrimaryLine = null;
      }
      if (this.SecondaryLine != undefined) {
        this.SecondaryLine = null;
      }
      if (this.PrimarySecondary != undefined && this.PrimarySecondary.preLines.length != 0) {
        this.PrimarySecondary.preLines = [];
      }
      if (this.sidebandFamily != undefined && this.sidebandFamily.state) {
        this.sidebandFamily.state = false;
      }

      // 构建更新的配置项
      let option = {
        title: [{
          id: 'offset',
          text: this.offset
        }, {
          id: 'Main-Cursor',
          text: this.mainCursor
        }, {
          id: 'Auxiliary-Cursor',
          text: this.auxiliaryCursor
        }],
        xAxis3D: [{
          name: '[Hz]',
          data: xData,
          axisLabel: {},
          nameTextStyle: {
            color: this.$store.state.selectbordercolor,
            fontSize: 10,
            padding: [0, 0, 10, 0],
          },
        }],
        tooltip: {},
        series: [{
          markPoint: {
            data: this.proMarkPoint.data
          },
          markLine: {
            data: []
          }
        }],
        toolbox: {
          feature: {
            mySidebandFamily: {
              iconStyle: {
                borderColor: null
              }
            }
          }
        }
      };

      this.markPoint.markPointX = [];

      if (this.change3DX.state == 'Hz') {
        // 恢复 Hz
        option.xAxis3D[0].data = this.change3DX.lastXData;
        option.tooltip.formatter = {}; // 清除 tooltip
        option.xAxis3D[0].axisLabel.formatter = function(val) {
          return parseInt(val);
        };

      } else {
        // 切换到 Order
        this.change3DX.lastXData = xData; // 备份 Hz 数据
        if (isCategory) {
          // category → 修改 data
          xData = xData.map((x) =>
            this.roundToDecimalPlaces((parseFloat(x) / this.change3DX.oneFrequency), 5) + 'X'
          );
          option.xAxis3D[0].data = xData;
        } else {
          // value → axisLabel 格式化
          option.xAxis3D[0].axisLabel.formatter = (val) => {
            return Math.round(val / this.change3DX.oneFrequency) + 'X';
          };
        }

        option.xAxis3D[0].name = '[Order]';
        // tooltip 兼容 value/category
        option.tooltip.formatter = (params) => {
          let rawX = isCategory
            ? parseFloat(params[0].axisValue)   // category
            : params[0].value[0];               // value 轴
          let orderX = this.roundToDecimalPlaces(rawX / this.change3DX.oneFrequency, 2) + 'X';
          return 'X:' + orderX + '\n' + 'Y:' + params[0].value[1];
        };
      }

      // 应用更新的配置
      chart.setOption(option);

      // 如果开启峰值搜索
      if (this.peakSearch.state) {
        this.peakSearchFun();
      }
    },

    /**
     * 标点功能开始
     */
    myMarkPointFun() {
      const chart = this.mychart
      //获取当前图表的option
      const op = chart.getOption();

      let option = {
        series: [] //op.series
      }

      if(!this.myMarkPoint.state) {
        // 需要关闭
        // this.myMarkPoint.state = false
        for(let i = 0; i < op.series.length; i++) {
          option.series.push({
            symbol: 'circle',
            symbolSize: 3,
            showSymbol: false,
            showAllSymbol: false,
          })
        }
        // if(this.axisPositionFlag) { // 取消标点，删除所有十字线
        //
        //   // console.log('op.series[0].markLine.data',op.series[0].markLine.data);
        //   // // 数组只保留前两个
        //   op.series[0].markLine.data = op.series[0].markLine.data.slice(0, 2);
        //   this.mychart.setOption(op);
        // }
      } else {
        // 需要打开
        // this.myMarkPoint.state = true
        for(let i = 0; i < op.series.length; i++) {
          option.series.push({
            // symbol: 'emptyCircle',
            symbol: 'circle',
            symbolSize: 3,
            showSymbol: true,
            showAllSymbol: true,
          })
        }
        // console.log('option',option)
      }



      this.mychart.setOption(option)
    },
    /**
     * 标点功能结束
     */
    markPointFunEnd() {
      const chart = this.mychart
      //获取当前图表的option
      const op = chart.getOption();
      let option = {
        series: [] //op.series
      }

      for(let seriesIndex in op.series) { // 清空所有series markPoint中的data
        if(op.series[seriesIndex].markPoint) {
          // option.series[seriesIndex].markPoint.data = []
          // console.log("happen->清空数据", seriesIndex)
          option.series.push({
            markPoint: {
              data : []
            }
          })
        }
      }
      this.mychart.setOption(option)
    },

    /**
     * 刷新图表标注显示
     */
    refreshMarkPointFun() {
      const chart = this.mychart
      //获取当前图表的option
      const op = chart.getOption();

      /**
       * 16进制颜色转rgba
       * @param sHex
       * @param alpha
       * @returns {string}
       */
      function colorRgba(sHex, alpha = 1) {
        // 十六进制颜色值的正则表达式
        var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{4}|[0-9a-fA-f]{6}|[0-9a-fA-f]{8})$/
        /* 16进制颜色转为RGB格式 */
        var sColor = sHex.toLowerCase()
        // var alpha = 1
        if (sColor && reg.test(sColor)) {
          if (sColor.length === 4 || sColor.length === 5) {
            var sColorNew = '#'
            for (var i = 1; i < sColor.length; i += 1) {
              sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1))
            }
            sColor = sColorNew
          }
          // 如果有透明度再执行
          if (sColor.length === 9) {
            alpha = this.roundToDecimalPlaces((parseInt('0x' + sColor.slice(7, 9))/255),2)
          }
          //  处理六位的颜色值
          var sColorChange = []
          for (var i = 1; i < 7; i += 2) {
            sColorChange.push(parseInt('0x' + sColor.slice(i, i + 2)))
          }
          return 'rgba(' + sColorChange.join(',') + ',' + alpha + ')'
        } else {
          return sColor
        }
      }

      let option = {
        series: []
      }

      // 标注的样式
      const markPointStyle = { // 绿色标注样式
        symbol: 'pin', // pin rect roundRect
        animation: false,
        label: {
          offset:[0, -5],
          show: true,
          fontWeight: 700,
          color: '#fff',
          textBorderWidth: 0,
          textBorderColor: '#fff',
          backgroundColor: 'rgba(57,191,104,0.9)',
          padding: [3, 4],
          borderRadius: 3,
        },
        itemStyle: {
          color: 'rgba(57,191,104,0.8)',
          // background: 'white',
        },
        symbolSize: [10, 30] , //标记大小 40
        data: [],
      }

      for(let seriesIndex in op.series) { // 清空所有series markPoint中的data
        option.series[seriesIndex] = {
          markPoint: JSON.parse(JSON.stringify(markPointStyle))
        }
        // console.log('happen->颜色',seriesIndex,op.series[seriesIndex].lineStyle.color )
        if(op.series[seriesIndex].lineStyle.color) {
          option.series[seriesIndex].markPoint.label.backgroundColor = colorRgba(op.series[seriesIndex].lineStyle.color, .8)
          option.series[seriesIndex].markPoint.itemStyle.color = colorRgba(op.series[seriesIndex].lineStyle.color, .4)
        }
      }
      //一倍频图标
      if (op.series[0].markPoint && op.series[0].markPoint.data && op.series[0].markPoint.data.length > 0) {
        for (let i = 0; i < op.series[0].markPoint.data.length; i++) {
          const point = op.series[0].markPoint.data[i];
          if (point.name === 'max' || point.name === '主游标点' || point.name === '辅游标点') {
            option.series[0].markPoint.data.push(point);
          }
        }
      }

      for(let point of this.markPoint.markPointX) {
        point = JSON.parse(point)
        let xName = point.xName // x轴的数值
        let seriesIndex = point.seriesNameIndex
        let y = point.y
        // xName = '123'
        // y = '60'
        // console.log("op.series[seriesIndex].name", op.series[seriesIndex].name)
        // console.log({value: `${xName}, ${y}` ,coord: [xName, y]})
        if(xName.indexOf('X') !== -1) {
          option.series[seriesIndex].markPoint.data.push({value: `${this.roundToDecimalPlaces(parseFloat(xName.substring(0, xName.length - 1)),2)}X, ${y}` ,coord: [xName, y]}) // , coord: [xName, y] xAxis: xName, yAxis: ''+y
        } else {
          option.series[seriesIndex].markPoint.data.push({value: `${xName}, ${y}` ,coord: [xName, y]}) // , coord: [xName, y] xAxis: xName, yAxis: ''+y
        }

      }
      this.mychart.setOption(option)
    },
    /**
     * 图表标注功能
     * 需要用到的临时变量变量全在this.markPoint中
     * @param x 触发时的x轴位置
     * @param seriesNameIndex
     * @param yIndex 触发时的y轴位置
     */
    markPointFun(x, seriesNameIndex = 0, yIndex, closePointIndex) {
      if(this.axisPositionFlag !== 'undefined' && this.axisPositionFlag) {
        this.addMarkPoint(x, yIndex, seriesNameIndex, closePointIndex);
        return ;
      }

      console.log(x, yIndex)
      const chart = this.mychart
      //获取当前图表的option
      const op = chart.getOption();
      let searchRange = 50;

      if(this.markPoint.isMark) { // 处在标注模式下
        // this.markPoint.markPointX保存当前标注过的坐标的信息
        let seriesIndex = seriesNameIndex
        let xName // x轴的值
        let y // y轴的值
        let chartHeight = chart.getHeight()
        let nowPointPixel = chart.convertToPixel({seriesIndex: seriesNameIndex}, [x, yIndex])
        console.log('标注', chart.getOption().series[seriesIndex].data[x]);
        //目前考虑只有波形图和频谱图使用可以去掉前部分，存在且有错误
        let modelFlag = this.typename == '趋势图' ? true : false;
        let yindexValue =  modelFlag ? chart.getOption().series[seriesIndex].data[x][1] : chart.getOption().series[seriesIndex].data[x];
        // if(typeof chart.getOption().series[seriesIndex].data[x] === 'number') {
        if(typeof yindexValue === 'number') {
          // 进行寻找离鼠标最近距离的一个点来进行标注
          let minDis = 99999999;
          let minX = 0;
          for(let i = x - searchRange; i < x + searchRange; i++) {
            if(i <= 0) continue
            let tx = i
            let ty = modelFlag ? chart.getOption().series[seriesIndex].data[i][1] : chart.getOption().series[seriesIndex].data[i]


            // 将图上的坐标，转换为真实的像素值，然后寻找离点击鼠标最近的距离的点
            let pointPixel = chart.convertToPixel({seriesIndex: seriesNameIndex}, [tx, ty]); //{seriesNameIndex: 0, x: 64, xName: '99.84', y: 12.4}

            let dis = (nowPointPixel[0] - pointPixel[0]) * (nowPointPixel[0] - pointPixel[0]) + (nowPointPixel[1] - pointPixel[1]) * (nowPointPixel[1] - pointPixel[1])
            if(dis < minDis) {
              minDis = dis
              minX = tx;
              // console.log(minDis, minX)
            }
          }
          x = minX
          console.log('标注2', chart.getOption().series[seriesIndex].data[minX], modelFlag);
          y = modelFlag ? chart.getOption().series[seriesIndex].data[minX][1] : chart.getOption().series[seriesIndex].data[minX] // 获取这个点对应的y值
          xName = '' + chart.getOption().xAxis[0].data[minX]
          // console.log(`初始点：${nowPointPixel}，获取到的点下标：${minX},像素${chart.convertToPixel({seriesIndex: seriesNameIndex}, [x, y])}`)

        } else {
          // 进行寻找离鼠标最近距离的一个点来进行标注
          let minDis = 99999999;
          let minX = 0;
          for(let i = x - searchRange; i < x + searchRange; i++) {
            if(i <= 0) continue
            let tx = i
            let ty = chart.getOption().series[seriesIndex].data[i][1]
            // 将图上的坐标，转换为真实的像素值，然后寻找离点击鼠标最近的距离的点
            let pointPixel = chart.convertToPixel({seriesIndex: seriesNameIndex}, [tx, ty]); //{seriesNameIndex: 0, x: 64, xName: '99.84', y: 12.4}
            let dis = (nowPointPixel[0] - pointPixel[0]) * (nowPointPixel[0] - pointPixel[0]) + (nowPointPixel[1] - pointPixel[1]) * (nowPointPixel[1] - pointPixel[1])
            if(dis < minDis) {
              minDis = dis
              minX = tx;
              // console.log(minDis, minX)
            }
          }
          x = minX
          y = chart.getOption().series[seriesIndex].data[minX][1] // 获取这个点对应的y值
          xName = '' + chart.getOption().series[seriesIndex].data[minX][0]
        }
        // 通过set处理传入的x轴信息，如果当前没有标注过，进行标注，标注过了则取消标注
        let markPointX = new Set(this.markPoint.markPointX)
        // console.log(markPointX)
        let setNode = {seriesNameIndex, x, xName, y} // {seriesNameIndex: 0, x: 64, xName: '99.84', y: 12.4}
        // console.log(setNode)
        setNode = JSON.stringify(setNode)
        if(markPointX.has(setNode)) {
          // console.log("happen-> 找到了")
          markPointX.delete(setNode)
        } else {
          // console.log("happen-> 找不到")
          markPointX.add(setNode)
        }
        this.markPoint.markPointX = [...markPointX] // 处理完毕，讲set转换成数组

        this.refreshMarkPointFun()
      } else { // 取消标注后处理的事件

      }
    },

    /**
     * 返回HistoryToolbox的feature
     */
    getHistoryToolboxFeature() {
      return {
        // 主副游标切换
        myPrimarySecondary: {
          title: !this.PrimarySecondary.isMark ? this.translateText("textMap.", "主游标") : this.translateText("textMap.", "辅游标"),
          show: true,
          // show: this.type=='real'? false:true,
          icon: this.PrimarySecondary.icon,
          iconStyle: {
            borderColor: this.PrimarySecondary.isMark ? null : '#74ACC8'
          },
          onclick:  ()=>{
            console.log('实时模式下的')
            let option = {
              toolbox: {
                feature: {
                  myPrimarySecondary: {
                    iconStyle: {
                      borderColor: '#74ACC8'
                    }
                  }
                }
              }
            }
            if(this.PrimarySecondary.isMark) {
              // console.log('当前是标记状态下')
              // 如果当前是主游标状态,需要切换为副游标
              this.PrimarySecondary.isMark = false;
              option.toolbox.feature.myPrimarySecondary.title = this.translateText("textMap.", "主游标")
              //
            } else {
              this.PrimarySecondary.isMark = true;
              option.toolbox.feature.myPrimarySecondary.iconStyle.borderColor = null
              option.toolbox.feature.myPrimarySecondary.title = this.translateText("textMap.", "辅游标")
            }
            this.mychart.setOption(option)
          }
        },

        // 标点
        myMarkPoint: {
          title: this.myMarkPoint.state ? this.translateText("textMap.", "取消标点") : this.translateText("textMap.", "标点"),
          icon: this.myMarkPoint.icon,
          // show: this.$route.path.indexOf('/WirelessPumpGraph') !== -1 && this.trendFlag ? false : true,
          show: true,
          iconStyle: {
            borderColor: this.myMarkPoint.state ?'#74ACC8' : null
          },
          onclick: () => {
            console.log('标点');
            let option = {
              toolbox: {
                feature: {
                  myMarkPoint: {
                    iconStyle: {
                      borderColor: '#74ACC8'
                    }
                  }
                }
              }
            }
            if(this.myMarkPoint.state) {
              // 还原图表线条颜色
              option.toolbox.feature.myMarkPoint.iconStyle.borderColor = null
              this.myMarkPoint.state = false
              option.toolbox.feature.myMarkPoint.title = this.translateText("textMap.", "标点")
            } else {
              this.myMarkPoint.state = true
              option.toolbox.feature.myMarkPoint.title =  this.translateText("textMap.", "取消标点")
            }
            this.myMarkPointFun()

            this.mychart.setOption(option)
          }
        },
        // 模式切换
        myModel: {
          // title: this.modelFlag ? '数据点等分' : '时间点等分',
          title: this.modelFlag ? this.translateText("textMap.", "数据点等分") : this.translateText("textMap.", "时间点等分"),
          show: false,
          icon: 'M252.6,26v194.6c0,5.8-4.5,10.5-10,10.5h-196c-5.5,0-10-4.7-10-10.5V26c0-5.8,4.5-10.5,10-10.5h196C248.2,15.4,252.6,20.2,252.6,26z M488.6,169.5c0-85.1-66.6-154.1-148.8-154.1 M485.7,242.6l47.7-71H438L485.7,242.6z M485.7,237.5l42.2-62.7h-84.3L485.7,237.5z M485.7,231.8l35.6-53H450L485.7,231.8z M485.7,226.3l29.8-44.3h-59.6L485.7,226.3z M485.7,219.2l23.3-34.7h-46.6L485.7,219.2z M485.7,213.8l17.7-26.4h-35.5L485.7,213.8z M485.7,199.2l2.4-3.7h-4.9L485.7,199.2z M485.7,200l3.6-5.4h-7.1L485.7,200z M485.7,201.1l5-7.5h-10L485.7,201.1z M485.7,203.4l6.9-10.3h-13.9L485.7,203.4z M485.7,206.6l10.2-15.1h-20.3L485.7,206.6z M485.7,209.6l12.9-19.3h-25.9L485.7,209.6z M296.5,318.5v194.6c0,5.8,4.5,10.5,10,10.5h196c5.5,0,10-4.7,10-10.5V318.5c0-5.8-4.5-10.5-10-10.5h-196C300.9,307.9,296.5,312.7,296.5,318.5z M58.5,369.5c0,85.1,66.6,154.1,148.8,154.1 M61.4,296.4l-47.7,71h95.4L61.4,296.4z M61.4,301.5l-42.2,62.7h84.3L61.4,301.5z M61.4,307.3l-35.6,53H97L61.4,307.3z M61.4,312.8l-29.8,44.3h59.6L61.4,312.8z M61.4,319.9l-23.3,34.7h46.6L61.4,319.9z M61.4,325.2l-17.7,26.4h35.5L61.4,325.2z M61.4,339.9l-2.4,3.7h4.9L61.4,339.9z M61.4,339.1l-3.6,5.4H65L61.4,339.1z M61.4,338l-5,7.5h10L61.4,338zM61.4,335.7L54.5,346h13.9L61.4,335.7z M61.4,332.4l-10.2,15.1h20.3L61.4,332.4z M61.4,329.5l-12.9,19.3h25.9L61.4,329.5z',
          onclick: () => {
            console.log('数据点等分');
            this.$store.state.modelFlag = !this.$store.state.modelFlag;
            this.modelFlag = !this.modelFlag;
            this.drawchart();
            this.setchartdata(this.flagX, this.flagY, this.dataX, this.dataY, this.title);
            let option = {
              toolbox: {
                feature: {
                  myModel: {
                    // title: this.modelFlag ? '数据点等分' : '时间点等分'
                    title: this.modelFlag ? this.translateText("textMap.", "数据点等分") : this.translateText("textMap.", "时间点等分"),
                  },
                  myMarkPoint: {
                    iconStyle: {
                      borderColor: null
                    },
                    title: this.translateText("textMap.", "标点"),
                  }
                }
              },
              // dataZoom: [{
              //   type: 'inside',
              //   start: 0,
              //   end: 100
              // }]
            };
            this.mychart.setOption(option);
            // this.updateMarkPoint()
            // this.setchartdata(this.flagX, this.flagY, this.dataX, this.dataY, this.title);
          }
        },
        // 标注
        myMark: {
          title: this.markPoint.isMark ? this.translateText("textMap.", "取消标注") : this.translateText("textMap.", "标注"),
          show: false,
          // show: this.type=='real' ? false: true,
          icon: this.markPoint.markIcon,
          iconStyle: {
            borderColor: this.markPoint.isMark ?'#74ACC8' : null
          },
          onclick:  ()=>{
            if((this.peakSearch != undefined && this.peakSearch.state) || (this.markLine != undefined && this.markLine.isResonance)){
              return
            }
            const currentOp = this.mychart.getOption();
            const cursorPoints = (currentOp.series[0].markPoint && currentOp.series[0].markPoint.data || []).filter(
              point => point.name === '主游标点' || point.name === '辅游标点'
            );
            let option = {
              series: [{
                markPoint: this.proMarkPoint
              }],
              toolbox: {
                feature: {
                  myMark: {
                    iconStyle: {
                      borderColor: '#74ACC8'
                    }
                  },
                  myDataZoomIn: {
                    iconStyle: {
                      borderColor: null,
                    }
                  },
                  mybrush: {
                    iconStyle: {
                      borderColor: null,
                    }
                  }
                }
              }
            }
            if(this.markPoint.isMark) {
              //取消标注 清空标记点

              this.markPoint.isMark = false;
              option.toolbox.feature.myMark.iconStyle.borderColor = null
              option.toolbox.feature.myMark.title = this.translateText("textMap.", "标注")
              this.delALLMarkPoint()
              if (option.series[0].markPoint && option.series[0].markPoint.data) {
                option.series[0].markPoint.data.push(...cursorPoints);
              } else {
                option.series[0].markPoint = { data: [...cursorPoints] };
              }
            } else {
              //this.mychart.getOption();
              console.log(this.mychart.getOption().toolbox[0].feature,"wdy")


              /*
              if(this.mychart.getOption().toolbox[0].feature.mybrush!=undefined){
                //标注禁用细化功能
                this.$store.state.brushState = false;
                option.toolbox.feature.mybrush.iconStyle.borderColor = this.$store.state.brushState ?'#74ACC8' : null;
              }*/


              this.markPoint.isMark = true;
              this.proMarkPoint = currentOp.series[0].markPoint;
              this.markPoint.markPointX = []
              option.toolbox.feature.myMark.title = this.translateText("textMap.", "取消标注")
              option.series[0].markPoint = {
                ...option.series[0].markPoint,
                data: [...cursorPoints] // 确保游标点被带入新的标注模式
              };
            }
            if(this.mychart.getOption().toolbox[0].feature.myDataZoomIn){
              // 如果有放大功能,点击标注后按钮保持不变
              // this.zoomState = false;
              option.toolbox.feature.myDataZoomIn.iconStyle.borderColor = this.zoomState ?'#74ACC8' : null;

              //this.mychart.setOption(option)
            }
            this.mychart.setOption(option)
          }
        },
      }
    },

    /**
     * 返回RealToolbox的feature
     * @returns {{myMark: {onclick, show: boolean, icon: string, title: string}}}
     */
    getRealToolboxFeature() {
      return {
        // 标点
        myMarkPoint: {
          title: this.myMarkPoint.state ? this.translateText("textMap.", "取消标点") : this.translateText("textMap.", "标点"),
          icon: this.myMarkPoint.icon,
          iconStyle: {
            borderColor: this.myMarkPoint.state ?'#74ACC8' : null
          },
          show: true,
          onclick: this.getHistoryToolboxFeature().myMarkPoint.onclick
        },
      }
    },
    getMyMarkPoint() {
      return {
        // 标点
        myMarkPoint: {
          title: this.myMarkPoint.state ? this.translateText("textMap.", "取消标点") : this.translateText("textMap.", "标点"),
          icon: this.myMarkPoint.icon,
          iconStyle: {
            borderColor: this.myMarkPoint.state ?'#74ACC8' : null
          },
          show: true,
          onclick: this.getHistoryToolboxFeature().myMarkPoint.onclick
        },
        // 标注
        myMark: {
          title: this.markPoint.isMark ? this.translateText("textMap.", "取消标注") : this.translateText("textMap.", "标注"),
          show: true,
          icon: this.markPoint.markIcon,
          onclick: this.getHistoryToolboxFeature().myMark.onclick
        }

      }
    },


    /**
     * 单独返回主副游标切换
     */
    getPrimarySecondary() {
      return {
        // 主副游标切换
        myPrimarySecondary: {
          title: !this.PrimarySecondary.isMark ? this.translateText("textMap.", "主游标") : this.translateText("textMap.", "辅游标"),
          show: true,
          // show: this.type=='real'? false:true,
          icon: this.PrimarySecondary.icon,
          iconStyle: {
            borderColor: this.PrimarySecondary.isMark ? null : '#74ACC8'
          },
          onclick:  ()=>{
            console.log('实时模式下的')
            let option = {
              toolbox: {
                feature: {
                  myPrimarySecondary: {
                    iconStyle: {
                      borderColor: '#74ACC8'
                    }
                  }
                }
              }
            }
            if(this.PrimarySecondary.isMark) {
              // console.log('当前是标记状态下')
              // 如果当前是主游标状态,需要切换为副游标
              this.PrimarySecondary.isMark = false;
              option.toolbox.feature.myPrimarySecondary.title = this.translateText("textMap.", "主游标")
              //
            } else {
              this.PrimarySecondary.isMark = true;
              option.toolbox.feature.myPrimarySecondary.iconStyle.borderColor = null
              option.toolbox.feature.myPrimarySecondary.title = this.translateText("textMap.", "辅游标")
            }
            this.mychart.setOption(option)
          }
        }
      }
    },

    /**
     * 单独返回标点
     */
    getMarkPoint() {
      return {
        // 标点
        myMarkPoint: {
          title: this.myMarkPoint.state ? this.translateText("textMap.", "取消标点") : this.translateText("textMap.", "标点"),
          icon: this.myMarkPoint.icon,
          // show: this.$route.path.indexOf('/WirelessPumpGraph') !== -1 && this.trendFlag ? false : true,
          show: true,
          iconStyle: {
            borderColor: this.myMarkPoint.state ?'#74ACC8' : null
          },
          onclick: () => {
            console.log('标点');
            let option = {
              toolbox: {
                feature: {
                  myMarkPoint: {
                    iconStyle: {
                      borderColor: '#74ACC8'
                    }
                  }
                }
              }
            }
            if(this.myMarkPoint.state) {
              // 还原图表线条颜色
              option.toolbox.feature.myMarkPoint.iconStyle.borderColor = null
              this.myMarkPoint.state = false
              option.toolbox.feature.myMarkPoint.title = this.translateText("textMap.", "标点")
            } else {
              this.myMarkPoint.state = true
              option.toolbox.feature.myMarkPoint.title =  this.translateText("textMap.", "取消标点")
            }
            this.myMarkPointFun()

            this.mychart.setOption(option)
          }
        }
      }
    },
    /**
     * 单独返回模式切换
     */
    getModel() {
      return {
        // 模式切换
        myModel: {
          // title: this.modelFlag ? '数据点等分' : '时间点等分',
          title: this.modelFlag ? this.translateText("textMap.", "数据点等分") : this.translateText("textMap.", "时间点等分"),
          show: false,
          icon: 'M252.6,26v194.6c0,5.8-4.5,10.5-10,10.5h-196c-5.5,0-10-4.7-10-10.5V26c0-5.8,4.5-10.5,10-10.5h196C248.2,15.4,252.6,20.2,252.6,26z M488.6,169.5c0-85.1-66.6-154.1-148.8-154.1 M485.7,242.6l47.7-71H438L485.7,242.6z M485.7,237.5l42.2-62.7h-84.3L485.7,237.5z M485.7,231.8l35.6-53H450L485.7,231.8z M485.7,226.3l29.8-44.3h-59.6L485.7,226.3z M485.7,219.2l23.3-34.7h-46.6L485.7,219.2z M485.7,213.8l17.7-26.4h-35.5L485.7,213.8z M485.7,199.2l2.4-3.7h-4.9L485.7,199.2z M485.7,200l3.6-5.4h-7.1L485.7,200z M485.7,201.1l5-7.5h-10L485.7,201.1z M485.7,203.4l6.9-10.3h-13.9L485.7,203.4z M485.7,206.6l10.2-15.1h-20.3L485.7,206.6z M485.7,209.6l12.9-19.3h-25.9L485.7,209.6z M296.5,318.5v194.6c0,5.8,4.5,10.5,10,10.5h196c5.5,0,10-4.7,10-10.5V318.5c0-5.8-4.5-10.5-10-10.5h-196C300.9,307.9,296.5,312.7,296.5,318.5z M58.5,369.5c0,85.1,66.6,154.1,148.8,154.1 M61.4,296.4l-47.7,71h95.4L61.4,296.4z M61.4,301.5l-42.2,62.7h84.3L61.4,301.5z M61.4,307.3l-35.6,53H97L61.4,307.3z M61.4,312.8l-29.8,44.3h59.6L61.4,312.8z M61.4,319.9l-23.3,34.7h46.6L61.4,319.9z M61.4,325.2l-17.7,26.4h35.5L61.4,325.2z M61.4,339.9l-2.4,3.7h4.9L61.4,339.9z M61.4,339.1l-3.6,5.4H65L61.4,339.1z M61.4,338l-5,7.5h10L61.4,338zM61.4,335.7L54.5,346h13.9L61.4,335.7z M61.4,332.4l-10.2,15.1h20.3L61.4,332.4z M61.4,329.5l-12.9,19.3h25.9L61.4,329.5z',
          onclick: () => {
            console.log('数据点等分');
            this.$store.state.modelFlag = !this.$store.state.modelFlag;
            this.modelFlag = !this.modelFlag;
            this.drawchart();
            this.setchartdata(this.flagX, this.flagY, this.dataX, this.dataY, this.title);
            let option = {
              toolbox: {
                feature: {
                  myModel: {
                    // title: this.modelFlag ? '数据点等分' : '时间点等分'
                    title: this.modelFlag ? this.translateText("textMap.", "数据点等分") : this.translateText("textMap.", "时间点等分"),
                  },
                  myMarkPoint: {
                    iconStyle: {
                      borderColor: null
                    },
                    title: this.translateText("textMap.", "标点"),
                  }
                }
              },
              // dataZoom: [{
              //   type: 'inside',
              //   start: 0,
              //   end: 100
              // }]
            };
            this.mychart.setOption(option);
            // this.updateMarkPoint()
            // this.setchartdata(this.flagX, this.flagY, this.dataX, this.dataY, this.title);
          }
        },
      }
    },
    /**
     * 单独返回标注
     */
    getMark() {
      return {
        // 标注
        myMark: {
          title: this.markPoint.isMark ? this.translateText("textMap.", "取消标注") : this.translateText("textMap.", "标注"),
          show: false,
          // show: this.type=='real' ? false: true,
          icon: this.markPoint.markIcon,
          iconStyle: {
            borderColor: this.markPoint.isMark ?'#74ACC8' : null
          },
          onclick:  ()=>{
            this.markOnclick()
          }
        },
      }
    },

    markOnclick(){
      let option = {
        toolbox: {
          feature: {
            myMark: {
              iconStyle: {
                borderColor: '#74ACC8'
              }
            }
          }
        }
      }
      if(this.markPoint.isMark) {
        this.markPoint.isMark = false;
        option.toolbox.feature.myMark.iconStyle.borderColor = null
        option.toolbox.feature.myMark.title = this.translateText("textMap.", "标注")
        this.delALLMarkPoint()
      } else {
        this.markPoint.isMark = true;
        this.markPoint.markPointX = []
        option.toolbox.feature.myMark.title = this.translateText("textMap.", "取消标注")
      }
      this.mychart.setOption(option)
    },

    getWavePoint(){
      return{
        myWavePoint:{
          show:false,
          title: this.showWavePointFlag ? this.translateText("textMap.",'显示全部点') : this.translateText("textMap.",'仅显示波形点'),
          onclick:() =>{
            if(this.markPoint.isMark) this.markOnclick() //先关闭标注
            this.showWavePointFlag = !this.showWavePointFlag
            this.showLangWavePointFlag = false
            this.setWavePoint()
            let option = {
              toolbox: {
                feature: {
                  myWavePoint: {
                    title: this.showWavePointFlag ? this.translateText("textMap.",'显示全部点') : this.translateText("textMap.",'仅显示波形点')
                  },
                  myLangWavePoint: {
                    title: this.showLangWavePointFlag ? this.translateText("textMap.",'显示全部点') : this.translateText("textMap.",'仅显示长波形点')
                  }
                }
              }
            }
            this.mychart.setOption(option)
          }
        },
      }
    },

    getLangWavePoint(){
      return{
        myLangWavePoint:{
          show:false,
          title: this.showLangWavePointFlag ? this.translateText("textMap.",'显示全部点') : this.translateText("textMap.",'仅显示长波形点'),
          onclick:() =>{
            if(this.markPoint.isMark) this.markOnclick() //先关闭标注
            this.showLangWavePointFlag = !this.showLangWavePointFlag
            this.showWavePointFlag = false
            this.setLangWavePoint()
            let option = {
              toolbox: {
                feature: {
                  myWavePoint: {
                    title: this.showWavePointFlag ? this.translateText("textMap.",'显示全部点') : this.translateText("textMap.",'仅显示波形点')
                  },
                  myLangWavePoint: {
                    title: this.showLangWavePointFlag ? this.translateText("textMap.",'显示全部点') : this.translateText("textMap.",'仅显示长波形点')
                  }
                }
              }
            }
            this.mychart.setOption(option)
          }
        },
      }
    },

    getAlarmLine(){
      return{
        myAlarmLine: {
          show: this.tongDaoType == '0',
          title: this.alarmFlag ? this.translateText('textMap.', '隐藏报警线') : this.translateText('textMap.', '显示报警线'),
          icon: "M0.5999999999999996 7a6.4 6.4 0 1 0 12.8 0a6.4 6.4 0 1 0 -12.8 0z M3.8 6.6L4.2 6.6 M10 10L3.7 10 M4.7 4.6L5 5 M7 4L7 4.4 M9 4.8L9.3 4.5 M9.7 6.6L10.2 6.6 M6.7 7.8L6.7 8.7 M8.5,9.6l0-2.6C8.3,5.3,5.8,5.3,5.6,7v2.6",
          iconStyle: {
            borderColor: this.alarmFlag ? '#74ACC8' : null,
            emphasis: {
              textPadding: [
                this.$store.state.paddingtop,
                this.$store.state.paddingright,
              ],
            },
          },
          onclick: () => {
            this.alarmFlag = !this.alarmFlag
            let option = {
              toolbox: {
                feature: {
                  myAlarmLine: {
                    title: this.alarmFlag ? this.translateText('textMap.', '隐藏报警线') : this.translateText('textMap.', '显示报警线'),
                    iconStyle: {
                      borderColor: this.alarmFlag ? '#74ACC8' : null
                    }
                  }
                }
              }
            }
            this.mychart.setOption(option)
            this.handleAlarm(this.alarmFlag);
            this.updateMarkPoint()
          }
        }
      }
    },

    handleAlarm(val) {
      if (val && this.tongDaoType == '0') {
        if(this.ifAlarm != 1){
          this.$message({
            message: this.translateText("textMap.",'没有设置报警门限'),
            type: 'warning'
          });
          return
        }
        if (this.aline.length > 0) {
          let amax = Number.NEGATIVE_INFINITY, amin = Number.POSITIVE_INFINITY;
          let tmp_data = [];
          let linedata = [];
          // let colorList = ['red', '#ffb700']
          let option = this.mychart.getOption();
          let unit = option.yAxis[0].name.slice(1,-1);
          let mySeries = option.series;
          for (let _item in mySeries) {
            for (let item in mySeries[_item].data) {
              if (option.xAxis[0].type != 'category') {
                amax = Math.max(amax, mySeries[_item].data[item][1]);
                amin = Math.min(amin, mySeries[_item].data[item][1]);
              } else {
                amax = Math.max(amax, mySeries[_item].data[item]);
                amin = Math.min(amin, mySeries[_item].data[item]);
              }
            }
          }
          this.aline.sort((a, b) => {
            return b['yAxis'] - a['yAxis'];
          })
          for (const i in this.aline) {
            this.aline[i].label = {
              position: this.positionMap[i]
            }
            this.aline[i].id = "alarmMarkLine"
            this.aline[i].lineStyle = {
              color: this.aline[i].name == '高高报' || this.aline[i].name == '低低报' ? 'red' : '#ffb700',
              type: "solid",
            };
            this.aline[i].label = {
              show: true,
              position: this.positionMap[i],
              formatter: ((param) => {
                var tmpname = this.translateText("textMap.",param.name);//对报警状态进行翻译
                return tmpname + ": " + param.data.value.toString() + unit;
              }),
            };
            linedata.push(this.aline[i]);
            tmp_data.push(this.aline[i].yAxis);
          }
          tmp_data.sort((num1, num2) => {
            return num2 - num1;
          });
          let markLineData = [];
          try{
            markLineData = this.mychart.getOption().series[0].markLine.data;
          }catch (e){}
          if(markLineData == undefined) markLineData = [];
          markLineData = markLineData.filter(i => {
            return i.id != "alarmMarkLine";
          })
          linedata.push(...markLineData);
          let markLine = {
            data: linedata,
            symbol: ['none', 'none'],
            animation: false,
          };
          amax = Math.max(amax, tmp_data[0]);
          amin = Math.min(amin, tmp_data[tmp_data.length - 1]);
          amax = this.roundUp(amin, amax)
          amin = this.roundDown(amin, amax)
          let myOption = {
            series: {
              markLine: markLine
            },
            yAxis: {
              axisLabel: {
                showMaxLabel: true,
                showMinLabel: true,
              },
              max: amax,
              min: amin,
            },
          };
          this.mychart.setOption(myOption);
        }else {
          this.$message({
            message: this.translateText("textMap.",'暂无报警线信息'),
            type: 'warning'
          });
        }
      } else {
        let option = this.mychart.getOption();
        let mySeries = option.series;
        let amax = Number.NEGATIVE_INFINITY, amin = Number.POSITIVE_INFINITY;
        for (let _item in mySeries) {
          for (let item in mySeries[_item].data) {
            if (option.xAxis[0].type != 'category') {
              amax = Math.max(amax, mySeries[_item].data[item][1]);
              amin = Math.min(amin, mySeries[_item].data[item][1]);
            } else {
              amax = Math.max(amax, mySeries[_item].data[item]);
              amin = Math.min(amin, mySeries[_item].data[item]);
            }
          }
        }
        let markLineData = mySeries[0].markLine.data;
        markLineData = markLineData.filter(i => {
          return i.id != "alarmMarkLine";
        })
        amax = this.roundUp(amin, amax)
        amin = this.roundDown(amin, amax)
        let myOption = {
          series: {
            markLine: {
              data: markLineData
            }
          },
          yAxis: {
            axisLabel: {
              showMaxLabel: true,
              showMinLabel: true,
            },
            max: amax,
            min: amin,
          },
        };
        this.mychart.setOption(myOption);
      }
    },

    /**
     * 导出趋势特征值为 Excel
     * @param {Array} trendInfoList - 趋势数据列表
     * @param {Array<string>} pointNames - 测点名称数组
     * @param {Array<Object>} features - 特征值字段数组 [{ label, unit, feature }]
     */
    exportTrendToExcel(response, pointType) {
      const rows = [];
      const features = this.$store.state.features[pointType];
      const pointNames = response.pointName.split(',');
      response.trendInfo.forEach((item) => {
        const time = timestampToTimeFormat(item.trendTime);
        const rev = item.rev;
        const trendValueList = item.trendValue;
        pointNames.forEach((pointName, index) => {
          const pointValue = trendValueList[index];
          if (!pointValue) return;

          const row = {
            [this.translateText('textMap.','时间')]: time,
            [this.translateText('textMap.','测点')]: pointName,
            [this.translateText('textMap.','转速')]: rev
          };

          features.forEach((f) => {
            const key = f.feature;
            const colName = `${this.translateText('textMap.', f.label)}`;
            row[colName] = pointValue[key];
          });

          rows.push(row);
        });
      });

      // 生成 worksheet 和 workbook
      const worksheet = XLSX.utils.json_to_sheet(rows);

      // 设置列宽
      const totalColumns = Object.keys(rows[0] || {}).length;
      worksheet["!cols"] = Array.from({ length: totalColumns }, (_, i) => ({
        wch: i <= 1 ? 25 : 15  // 第一、二列宽 25，其他列宽 15
      }));

      // 设置表头样式（第一行）
      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const headerCell = worksheet[XLSX.utils.encode_cell({ r: 0, c: C })];
        if (headerCell) {
          headerCell.s = {
            font: { bold: true },
            fill: { fgColor: { rgb: "DCE6F1" } },
            alignment: { horizontal: "center", vertical: "center" }
          };
        }
      }

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, this.translateText('textMap.','趋势特征值'));

      const fileName = `${this.translateText('textMap.','趋势特征值')}.xlsx`;
      XLSX.writeFile(workbook, fileName);
    },
  }
};

/**
 * 图表的公共toolbox
 */
export default toolboxMixin



// WEBPACK FOOTER //
// ./src/mixins/toolboxMixin.js